import React from 'react';

import Tooltip from '~/components/core/Atomic/Tooltip';
import StatusChip from '~/components/core/StatusChip';
import { GeneratedReportListResponseGeneratedReportStatus } from '~/server_shared/openapi/data-contracts';

interface ReportStatusBadgeProps {
  status: GeneratedReportListResponseGeneratedReportStatus;
  errorMessage?: string | null;
  className?: string;
}

const ReportStatusBadge: React.FC<ReportStatusBadgeProps> = ({ status, errorMessage, className }) => {
  const getStatusForChip = (status: GeneratedReportListResponseGeneratedReportStatus) => {
    switch (status) {
      case GeneratedReportListResponseGeneratedReportStatus.Completed:
        return StatusChip.STATUSES.SUCCESS;
      case GeneratedReportListResponseGeneratedReportStatus.Failed:
        return StatusChip.STATUSES.ERROR;
      case GeneratedReportListResponseGeneratedReportStatus.Processing:
        return StatusChip.STATUSES.IN_PROGRESS;
      case GeneratedReportListResponseGeneratedReportStatus.Initial:
        return StatusChip.STATUSES.PENDING;
    }
  };

  const isFailed = status === GeneratedReportListResponseGeneratedReportStatus.Failed;

  return isFailed && errorMessage ? (
    <Tooltip title={<span className="text-sm">{errorMessage}</span>} placement="top">
      <div className={className}>
        <StatusChip status={getStatusForChip(status)} withIcon />
      </div>
    </Tooltip>
  ) : (
    <div className={className}>
      <StatusChip status={getStatusForChip(status)} withIcon />
    </div>
  );
};

export default ReportStatusBadge;
